// extracted by mini-css-extract-plugin
module.exports = {"animateBlink":"CLobby_animateBlink__soVzA","blink":"CLobby_blink__f_b2i","removeAnimation":"CLobby_removeAnimation__jT_Yw"};